import {
  HEADER_CONSTANTS,
  MEDIA_QUERIES,
} from '@porterin/booking-flow/src/common/domain/config/constants';

export const getBookingFlowSource = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.matchMedia(MEDIA_QUERIES.MIN_DESKTOP).matches
    ? HEADER_CONSTANTS.DESKTOP_SOURCE
    : HEADER_CONSTANTS.MOBILE_SOURCE;
};
